/**
 * Created by: Dan Oproiu
 * Date: 04.06.2018
 */

TS.ns('TS.cultures');

(function (window, undefined) {
    TS.cultures['hr'] = {
        name: 'hr', 
        language: "hr",
        decimalseparator: ',',
        thousandsseparator: '.',
        numberFormat: {
            pattern: ["- n"],
            decimals: 2,
            ",": ".",
            ".": ",",
            groupSize: [3],
            percent: {
                pattern: ["-n%", "n%"],
                decimals: 2,
                ",": ".",
                ".": ",",
                groupSize: [3],
                symbol: "%"
            },
            currency: {
                pattern: ["-n $", "n $"],
                decimals: 2,
                ",": ".",
                ".": ",",
                groupSize: [3],
                symbol: "kn"
            }
        },
        common: {
            Add: 'Add',
            Edit: 'Edit',
            Delete: 'Delete',
            Save: 'Save',
            Close: 'Close',
            Cancel: 'Cancel',
            Confirm: 'Confirm',
            Yes: 'Yes',
            No: 'No',
            EmptySelection: '<unspecified>'
        },

        sessionExpired: {
            Title: 'Session has expired',
            Message: 'Redirecting to start page.'
        },

        error: {
            LoadError: 'Error loading data'
        },

        edit: {
            InvalidDocument: 'This document is not valid. Fix validation errrors and try again.'
        },

        list: {
            NoRecordSelected: 'Select at least one record',
            DeleteSelectedRecords: 'Are you sure you want to delete selected records?'
        },

        gridLocalization: {
            days: {
                names: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "četvrtak", "petak", "subota"],
                namesAbbr: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
                namesShort: ["ne", "po", "ut", "sr", "če", "pe", "su"]
            },
            months: {
                names: ["siječanj", "veljača", "ožujak", "travanj", "svibanj", "lipanj", "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac", ""],
                namesAbbr: ["sij", "vlj", "ožu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro", ""]
            },
            AM: [""],
            PM: [""],
            patterns: {
                // short date pattern
                d: "d.M.yyyy.",
                // long date pattern
                D: "d. MMMM yyyy.",
                // short time pattern
                t: "H:mm",
                // long time pattern
                T: "H:mm:ss",
                // long date, short time pattern
                f: "d. MMMM yyyy. H:mm tt",
                // long date, long time pattern
                F: "d. MMMM yyyy. H:mm:ss",
                // month/day pattern
                m: "d. MMMM",
                // month/day pattern
                M: "d. MMMM",
                // S is a sortable format that does not vary by culture
                S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                // formatting of dates in MySQL DataBases
                ISO: "yyyy-MM-dd hh:mm:ss",
                ISO2: "yyyy-MM-dd HH:mm:ss",
                d1: "d.M.yyyy.",
                d2: "d-M-yyyy",
                d3: "dd-MMMM-yyyy",
                d4: "dd-MM-yy",
                d5: "H:mm",
                d6: "HH:mm",
                d7: "HH:mm tt",
                d8: "dd/MMMM/yyyy",
                d9: "MMMM-dd",
                d10: "dd-MM",
                d11: "dd-MM-yyyy"
            },

            "/": ".",
            ":": ":",
            firstDay: 1,
            eras: [
                // eras in reverse chronological order.
                // name: the name of the era in this culture (e.g. A.D., C.E.)
                // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                // offset: offset in years from gregorian calendar
                { "name": "A.D.", "start": null, "offset": 0 }
            ],
            twoDigitYearMax: 2029,
            percentsymbol: "%",
            currencysymbol: "HRK",
            currencysymbolposition: "forward",
            decimalseparator: ',',
            thousandsseparator: ' ',
            pagergotopagestring: "Go to page:",
            pagershowrowsstring: "Rows no.:",
            pagerrangestring: " of ",
            pagerpreviousbuttonstring: "Previous page",
            pagernextbuttonstring: "Next page",
            groupsheaderstring: "Drag a column and drop it here to group",
            sortascendingstring: "Sort ascending",
            sortdescendingstring: "Sort descending",
            sortremovestring: "Remove ordering",
            groupbystring: "Group by this column",
            groupremovestring: "Remove from groups",
            filterclearstring: "Clear",
            filterstring: "Filter",
            filtershowrowstring: "Show rows:",
            filterorconditionstring: "Or",
            filterandconditionstring: "And",
            filterselectallstring: "(Select all)",
            filterchoosestring: "Choose:",
            filterstringcomparisonoperators: ['unspecified', 'specified', 'contain', 'contain(match letters)',
                'does not contain', 'does not contain(match letters)', 'starts with', 'starts with(match letters)',
                'ends with', 'ends with(match letters)', 'equal', 'equal(match letters)', 'null', 'not null'],
            filternumericcomparisonoperators: ['equal', 'unequal', 'less than', 'less than or equal to', 'greater then', 'greater or equal to', 'null', 'not null'],
            filterdatecomparisonoperators: ['equal', 'unequal', 'less than', 'less than or equal to', 'greater then', 'greater or equal to', 'null', 'not null'],
            filterbooleancomparisonoperators: ['equal', 'unequal'],
            validationstring: "The value entered is not valid",
            emptydatastring: "No data",
            filterselectstring: "Select filter",
            loadtext: "Loading...",
            clearstring: "Delete",
            todaystring: "Today",
            emptyContent: 'No data'
        },

        treeLocalization: {
            AddRoot: 'Add root',
            ExpandAll: 'Expand all',
            CollapseAll: 'Collapse all'
        },

        pagerMessages: {
            display: "Record {0} - {1} of {2}",
            empty: "No data",
            page: "Page",
            of: "of {0}",
            itemsPerPage: "records per page",
            first: "First page",
            previous: "Previous page",
            next: "Next page",
            last: "Last page",
            refresh: "Refresh",
            morePages: "More pages"
        },

        validation: {
            RequiredValue: 'Enter the value',
            InvalidValue: 'The value entered is not valid'
        },

        messageBox: {
            buttons: {
                OK: 'OK',
                Cancel: 'Cancel',
                Abort: 'Abort',
                Retry: 'Retry',
                Ignore: 'Ignore',
                Yes: 'Yes',
                No: 'No'
            }
        },

        fileUploadMessages: {
            Loading: 'Loading...',
            Error: 'Error',
            SelectFile: 'Load',
            InitialDescription: 'Press "Load" button',
            DragOverHint: 'Release the file to start loading.',
            UploadCancelled: 'Loading stopped'
        }
    }
})(this);


(function ($) {
    $.dateEntry.regionalOptions['hr'] = {
        dateFormat: 'dmy.',
        monthNames: ['siječanj', 'veljača', 'ožujak', 'travanj', 'svibanj', 'lipanj', 'srpanj', 'kolovoz', 'rujan', 'listopad', 'studeni', 'prosinac'],
        monthNamesShort: ['Sij', 'Vlj', 'Ožu', 'Tra', 'Svi', 'Lip', 'Srp', 'Kol', 'Ruj', 'Lis', 'Stu', 'Pro'],
        dayNames: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
        dayNamesShort: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
        spinnerTexts: ['Jetzt', 'vorheriges Feld', 'nächstes Feld', 'hoch', 'runter']
    };
    $.dateEntry.setDefaults($.dateEntry.regionalOptions['hr']);
})(jQuery);